export interface IItemParams {
    color: string; // np. #ff0000, red, rgb(255,0,0)
    url: string;   // np. link, Base64
    text: string;
    isPopoverOpen: boolean;
    callback: () => void;
    isSelected: boolean;
    isDisabled: boolean;
}

export class ItemParams implements IItemParams {
    constructor(
        public color: string,
        public url: string,
        public text: string,
        private _callback: (self: IItemParams) => void,
        private _isSelected: () => boolean = () => true,
        private _isDisabled: () => boolean = () => false,
        public isPopoverOpen: boolean = false,
    ) { }

    public get isSelected(): boolean {
        return this._isSelected();
    }

    public get isDisabled(): boolean {
        return this._isDisabled();
    }

    public callback() { this._callback(this); }
}
